import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { setAuthStoreRef } from './api/client'
import { useAuthStore } from './stores/auth-store'

// Wire up standalone auth store reference
setAuthStoreRef(() => useAuthStore.getState())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
